const config = {
    id: 22,
    name: "达标返",
    type: 1,
    module_code: "user_kpi",
    icon: "icon-tms-user_kpi",
    font_icon: "&#xe898;",
    style_type: 1,
    link_type: 0,
    link_data: [],
    property_data: {
        bjzs_color: "#0F3DAE", //背景主色
        bjfzs_color: "#FFFFFF", //背景辅助色
        smwa_color: "#666666", //说明文案颜色
        tcwa_color: "#FF6000", //突出文案颜色
        tcwabj_color: "#FFD6C3", //突出文案背景颜色
        smwabj_color: "#BFBBBF", //说明文案背景颜色
        cywabj_color: "#F6F6F6", //次要文案背景颜色
        jdtbj_color: "#FFD6C3", //达标返进度背景
        jdt_color: "#FF6000", //达标返进度条
        yr_header_text: "", // 预热期头部文案
        yr_footer_text: "", // 预热期底部文案
        rule_img_items: [], //达标返节点图标
        rule_color: "#002580", //活动规则颜色
        rule_text: "规则", // 活动规则文案
        rule_link: "" // 活动规则链接
    }
};

export default config;